import React from "react";
import userContext from '../../../userContext'

export default function HomeDetails(props) {
    const context = React.useContext(userContext)
    const burl = context.getBurl()

    let actualHome = props.sel.property
    let homeData = props.data

    if (homeData && homeData.properties.map((property) => property.name).includes(actualHome)) {
        const home = homeData.properties.find((property) => property.name === actualHome);

        return (
            <div className="home-details">
                {home.homeView?.map((data, index) => {
                    const title = data.title
                    const text = data.text
                    const images = data.images?.map((image) => {
                        return burl + "/uploads/" + image
                    });

                    return (
                        <div className="hd-card" key={index}>
                            <div className="hd-card__header">
                                <h3>{title}</h3>
                            </div>
                            <div className="hd-card__body">
                                {text && text.split('\n').map((line, lineIndex) => (
                                    <p key={lineIndex}>{line}</p>
                                ))}
                            </div>
                            {images && images.length > 0 && (
                                <div className="hd-card__images">
                                    {images.map((url, imgIndex) => (
                                        <img key={imgIndex} src={url} alt={`${title} - ${imgIndex + 1}`} />
                                    ))}
                                </div>
                            )}
                        </div>
                    )
                })}
            </div>
        )
    }

    return (
        <div className="home-details">
            <div className="hd-error">
                <p>Aucune information disponible pour cette propriété.</p>
            </div>
        </div>
    )
}
